@if ({ listenForLargeScreen: listenForLargeScreen$ | async }; as componentData) {
  @if (isHomePage || componentData.listenForLargeScreen) {
    @if ({ loggedIn: loggedIn$ | async }; as comp) {
      <header>
        <nav class="nav">
          <a class="brand pl-2 me-3" [routerLink]="['/']">
            @if (componentData.listenForLargeScreen) {
              <img class="logo" src="./assets/images/realty-bid-logo-full.svg" alt="logo" />
            }
            @if (!componentData.listenForLargeScreen) {
              <img class="logo" src="./assets/images/realty-bid-logo-sm.svg" alt="logo" />
            }
          </a>
          <div class="nav-content">
            <app-nav class="nav-component" [isHomePage]="isHomePage" />
          </div>
        </nav>
      </header>
    }
  }
}
